'use client';

import { useLanguage } from '@/contexts/LanguageContext';

const AboutSection = () => {
  const { language } = useLanguage();
  const isRTL = language === 'ar';

  const content = {
    ar: {
      title: 'من نحن',
      description: 'مكتب لو باكت للمحاماة والاستشارات القانونية يقدم خدمات قانونية متخصصة في مختلف المجالات القضائية. نحرص على تقديم استشارات دقيقة ومتابعة مستمرة لضمان تحقيق أفضل النتائج لعملائنا.'
    },
    en: {
      title: 'About Us',
      description: 'Law Pact is a law firm providing specialized legal services in various judicial fields. We ensure accurate consultations and continuous follow-up to achieve the best results for our clients.'
    }
  };

  const t = content?.[language];

  return (
    <section data-component-id="src/app/landing-page/components/AboutSection.tsx:23:4" data-component-path="src/app/landing-page/components/AboutSection.tsx" data-component-line="23" data-component-end-line="38" data-component-file="AboutSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22about%22%2C%22className%22%3A%22py-16%20bg-background%22%7D"
      id="about"
      className="py-16 bg-background"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div data-component-id="src/app/landing-page/components/AboutSection.tsx:28:6" data-component-path="src/app/landing-page/components/AboutSection.tsx" data-component-line="28" data-component-end-line="37" data-component-file="AboutSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22container%20mx-auto%20px-4%20lg%3Apx-10%22%7D" className="container mx-auto px-4 lg:px-10">
        <div data-component-id="src/app/landing-page/components/AboutSection.tsx:29:8" data-component-path="src/app/landing-page/components/AboutSection.tsx" data-component-line="29" data-component-end-line="36" data-component-file="AboutSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-4xl%20mx-auto%20text-center%22%7D" className="max-w-4xl mx-auto text-center">
          <h2 data-component-id="src/app/landing-page/components/AboutSection.tsx:30:10" data-component-path="src/app/landing-page/components/AboutSection.tsx" data-component-line="30" data-component-end-line="32" data-component-file="AboutSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-playfair%20font-bold%20text-3xl%20md%3Atext-4xl%20text-primary%20mb-6%22%7D" className="font-playfair font-bold text-3xl md:text-4xl text-primary mb-6">
            {t?.title}
          </h2>
          <p data-component-id="src/app/landing-page/components/AboutSection.tsx:33:10" data-component-path="src/app/landing-page/components/AboutSection.tsx" data-component-line="33" data-component-end-line="35" data-component-file="AboutSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22font-inter%20text-lg%20text-text-secondary%20leading-relaxed%20mb-6%22%7D" className="font-inter text-lg text-text-secondary leading-relaxed mb-6">
            {t?.description}
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;